import './UpLink.css';
import { t } from '../../copy/strings';
import { upOne } from '../../state/actions';
import { useLayout } from '../../state/hooks';

export interface UpLinkProps {
  /** Nome do lugar de cima, como aparece ("São Paulo", "Exterior", "Portugal"). */
  to: string;
  /** Nome acessível; padrão `place.up.aria` ("Voltar para {lugar}", que contém o texto visível, 2.5.3). */
  label?: string;
  /** Padrão `upOne()`, a coluna `‹` de §5.5.3 (o dono sobrescreve quando o destino é outro). */
  onClick?: () => void;
}

/**
 * "‹ {lugar acima}" (§8.1): só em município, zona, país e cidade do exterior (Fase 7b). Pílula sem borda, alvo de toque
 * ampliado a 44 px por pseudo-elemento. Na TV não existe: no lugar dele entra o kicker da cena (§12.2).
 */
export function UpLink({ to, label, onClick }: UpLinkProps) {
  if (useLayout().mode === 'tv') return null;
  return (
    <button
      type="button"
      class="up-link"
      data-testid="up-link"
      aria-label={label ?? t('place.up.aria', { LUGAR: to })}
      onClick={() => (onClick ? onClick() : upOne())}
    >
      <span class="up-link__text">{t('place.up', { LUGAR: to })}</span>
    </button>
  );
}
